import {Component, Input, OnInit} from '@angular/core';
import {ReportFilter} from '../../../models/dealers/dealer-filter.model';
import {HttpService} from '../../../services/http.service';
import {DealerData} from '../../../models/Report/dealerData.modal';


@Component({
  selector: 'app-credit-note-summary',
  templateUrl: './credit-note-summary.component.html',
  styleUrls: ['./credit-note-summary.component.scss']
})
export class CreditNoteSummaryComponent implements OnInit {
  filter: ReportFilter = new ReportFilter();
  dealerData: DealerData = new DealerData();
  searchText = '';
  total = 0;
  @Input() dealerName: any[] = [];

  constructor(private http: HttpService) {
  }

  ngOnInit(): void {
    this.refreshList();
  }

  orderBy(field: string) {
    if (this.filter.orderBy === field) {
      if (this.filter.order === 'ASC') {
        this.filter.order = 'DESC';
      } else {
        this.filter.order = 'ASC';
      }
    }
    this.filter.orderBy = field;
    this.refreshList();
  }

  refreshList() {
    if (this.filter.dealerNumber === 'null') {
      this.filter.dealerNumber = null;
    }
    this.http.getCreditNoteReportItems(this.filter).subscribe((res: DealerData) => {
      this.dealerData = Object.assign(new DealerData(), res);
    });
  }

  exportCreditNoteReportAsXLSX(dealer) {
    const data = {
      dealerNumber: dealer.dealerNumber,
      exportDate: dealer.exportDate
    };
    this.http.downloadDealerCreditNoteReport(data);
  }


  amount(invoice: any): string {
    const amount = invoice.total;
    return `EUR ${amount}`;
  }

  showDirectionImage(): string {
    if (this.filter.orderBy === 'ASC') {
      return 'assets/images/icon-sort-up.png';
    } else {
      return 'assets/images/icon-sort-down.png';
    }
  }

  clearFilter() {
    this.filter = new ReportFilter();
    this.refreshList();
  }

  changePage(count: number) {
    this.filter.page += count;
    this.refreshList();
  }
}
